<template>
  <div v-if="items">
    <invoice-item
      v-for="(item, itemIndex) in items"
      :key="item"
      :ref="`invoice-item-${invoiceId}-${item}`"
      :index="itemIndex"
      :active-item="activeChild"
      :invoice-id="invoiceId"
      :product-id="item"
      @focused="$emit('focused', $event)"
      class="mt-6 shadow-lg"
    />
  </div>
</template>

<script>
import InvoiceItem from '@/components/InvoiceItem.vue'

export default {
  name: 'InvoiceItems',
  components: {
    InvoiceItem
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeChild: {
      type: Number,
      required: false,
      default: -1
    },
    invoiceId: {
      type: String,
      required: true
    }
  }
}
</script>
